import { render, staticRenderFns } from "./PlaylistsPanelTeacherItemCard.vue?vue&type=template&id=56269252&scoped=true&"
import script from "./PlaylistsPanelTeacherItemCard.vue?vue&type=script&lang=ts&"
export * from "./PlaylistsPanelTeacherItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistsPanelTeacherItemCard.vue?vue&type=style&index=0&id=56269252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56269252",
  null
  
)

export default component.exports